module.exports = __webpack_public_path__ + "img/logo_vertical.b599b705.svg";